import { history } from "../../src/index";

import * as jwt from 'jsonwebtoken';
import * as types from '../constants/userdetails';
import * as toasterTypes from '../constants/ActionTypes';
import * as teamtypes from '../constants/teamdetails';
import * as userdetailsApi from '../api/userdetails';
import * as teamdetailsAction from './teamdetails';


export function login(objModel) {
    // console.log("login action call",objModel);
    return dispatch => {
        dispatch({ type: types.USER_LOGG_IN_REQUEST });
        dispatch({ type: teamtypes.FETCH_SWITCH_TEAM_LIST_REQUEST_RESET, data: null });
        userdetailsApi.login(objModel)
            .then(function (response) {
                // console.log("login action succ ", response);
                localStorage.setItem('TOKEN', response.data.token);
                localStorage.setItem('ROLELIST', JSON.stringify(response.data.roleList));
                localStorage.setItem('GRANTENABLED', JSON.stringify(response.data.grantEnabled));
                var payload = jwt.decode(response.data.token);
                if (payload && payload.commite_id)
                    payload.committee_id = payload.commite_id
                dispatch({ type: types.USER_LOGG_IN_REQUEST_COMPLETED, payload: payload, token: response.data.token, roleList: response.data.roleList,grantEnabled:response.data.grantEnabled });
            })
            .catch(function (err) {
                // console.log("login action err ", err);
                dispatch({ type: types.USER_LOGG_IN_REQUEST_ERROR, error: err });
            });
    }
}

export function postLogin(objModel) {
    // console.log("login action call",objModel);
    // console.log("login action call localStorage.getItem('ROLELIST')", localStorage.getItem('ROLELIST'));
    return dispatch => {
        var payload = jwt.decode(objModel);
        if (payload && payload.commite_id)
            payload.committee_id = payload.commite_id
        if (localStorage.getItem('ROLELIST') == 'undefined')
            history.push('/login');
        else
            dispatch({ type: types.USER_LOGG_IN_REQUEST_COMPLETED, payload: payload, token: objModel, roleList: JSON.parse(localStorage.getItem('ROLELIST')),grantEnabled:JSON.parse(localStorage.getItem('GRANTENABLED'))});

    }
}

export function notAuthorised() {

}

export function logout() {
    localStorage.setItem('TOKEN', '');
    localStorage.setItem('ROLELIST', '');
    // console.log('token', localStorage.getItem('TOKEN'));

    return dispatch => {
        dispatch({ type: teamtypes.FETCH_SWITCH_TEAM_LIST_REQUEST_RESET, data: null });
        dispatch({ type: types.USER_LOGGED_OUT });
    }
}

export function changepassword(oldPass, newPass) {
    // console.log("resetpassword action call",objModel);
    return dispatch => {
        dispatch({ type: types.CHANGE_PASSWORD_REQUEST });
        userdetailsApi.changepassword(oldPass, newPass)
            .then(function (response) {
                // console.log("resetpassword action succ", response)
                if (response.status == 200) {
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: JSON.stringify(response.data.messageEn) });
                }
                dispatch({ type: types.CHANGE_PASSWORD_REQUEST_COMPLETED });
            })
            .catch(function (err) {
                // console.log("resetpassword action err", err)
                dispatch({ type: types.CHANGE_PASSWORD_REQUEST_ERROR });
            });
    }
}

export function changeRole(role_id) {
    // console.log("changeRole action call",objModel);
    return dispatch => {
        dispatch({ type: types.CHANGE_PASSWORD_REQUEST });
        dispatch({ type: teamtypes.FETCH_SWITCH_TEAM_LIST_REQUEST_RESET, data: null });
        userdetailsApi.changeRole(role_id)
            .then(function (response) {
                console.log("changeRole action succ ", response);
                localStorage.setItem('TOKEN', response.data.token);
                var payload = jwt.decode(response.data.token);
                console.log("payload ", payload);
                if (payload && payload.commite_id)
                    payload.committee_id = payload.commite_id
                if (localStorage.getItem('ROLELIST') == 'undefined')
                    history.push('/login');
                else {
                    dispatch({ type: types.USER_LOGG_IN_REQUEST_COMPLETED, payload: payload, token: response.data.token, roleList: JSON.parse(localStorage.getItem('ROLELIST')),grantEnabled:JSON.parse(localStorage.getItem('GRANTENABLED')) });
                    dispatch({ type: types.CHANGE_PASSWORD_REQUEST_COMPLETED });
                }
            })
            .catch(function (err) {
                // console.log("changeRole action err ", err);
                dispatch({ type: types.CHANGE_PASSWORD_REQUEST_ERROR });
            });
    }
}

export function resetUser() {
    // console.log("resetCustomer action call");
    return dispatch => {
        dispatch({ type: types.FETCH_USER_REQUEST_RESET });
    }
}

export function getUserAD(name) {
    // console.log("getUserDetails action call");
    return dispatch => {
        dispatch({ type: types.FETCH_USER_REQUEST });
        userdetailsApi.getUserAD(name)
            .then(function (response) {
                // console.log("getUserDetails Action succ==>", response)
                dispatch({ type: types.FETCH_USER_REQUEST_COMPLETED, data: response.data });
            })
            .catch(function (err) {
                // console.log("getUserDetails action Error", err)
                dispatch({ type: types.FETCH_USER_REQUEST_ERROR, error: err });
            });
    }
}

export function getUserDetails(id) {
    // console.log("getUserDetails action call");
    return dispatch => {
        dispatch({ type: types.FETCH_USER_REQUEST });
        userdetailsApi.getUser(id)
            .then(function (response) {
                // console.log("getUserDetails Action succ==>", response)
                dispatch({ type: types.FETCH_USER_REQUEST_COMPLETED, data: response.data });
            })
            .catch(function (err) {
                // console.log("getUserDetails action Error", err)
                dispatch({ type: types.FETCH_USER_REQUEST_ERROR, error: err });
            });
    }
}

export function getPendingUserDetails(id) {
    // console.log("getUserDetails action call");
    return dispatch => {
        dispatch({ type: types.FETCH_USER_REQUEST });
        userdetailsApi.getPendingUser(id)
            .then(function (response) {
                // console.log("getUserDetails Action succ==>", response)
                dispatch({ type: types.FETCH_USER_REQUEST_COMPLETED, data: response.data });
            })
            .catch(function (err) {
                // console.log("getUserDetails action Error", err)
                dispatch({ type: types.FETCH_USER_REQUEST_ERROR, error: err });
            });
    }
}

export function getUserDetailsList(id) {
    // console.log("getUserDetailsList action call", id);
    return dispatch => {
        dispatch({ type: types.FETCH_USER_LIST_REQUEST });
        userdetailsApi.getUserList(id)
            .then(function (response) {
                // console.log("getUserDetailsList Action succ==>", response)
                dispatch({ type: types.FETCH_USER_LIST_REQUEST_COMPLETED, data: response.data.userList });
            })
            .catch(function (err) {
                // console.log("getUserDetailsList action Error", err)
                dispatch({ type: types.FETCH_USER_LIST_REQUEST_ERROR, error: err });
            });
    }
}

export function getUserOrderDetailsList(id) {
    // console.log("getUserOrderDetailsList action call",id);
    return dispatch => {
        dispatch({ type: types.FETCH_USER_LIST_REQUEST });
        userdetailsApi.getUserOrderList(id)
            .then(function (response) {
                // console.log("getUserDetailsList Action succ==>", response)
                dispatch({ type: types.FETCH_USER_LIST_REQUEST_COMPLETED, data: response.data.userList });
            })
            .catch(function (err) {
                // console.log("getUserDetailsList action Error", err)
                dispatch({ type: types.FETCH_USER_LIST_REQUEST_ERROR, error: err });
            });
    }
}

export function getPendingApprovalList() {
    // console.log("getPendingApprovalList action call");
    return dispatch => {
        dispatch({ type: types.FETCH_USER_LIST_REQUEST });
        userdetailsApi.getPendingApprovalList()
            .then(function (response) {
                // console.log("getPendingApprovalList Action succ==>", response)
                dispatch({ type: types.FETCH_USER_LIST_REQUEST_COMPLETED, data: response.data.userList });
            })
            .catch(function (err) {
                // console.log("getPendingApprovalList action Error", err)
                dispatch({ type: types.FETCH_USER_LIST_REQUEST_ERROR, error: err });
            });
    }
}

export function getRejectedRolesList() {
    // console.log("getRejectedRolesList action call");
    return dispatch => {
        dispatch({ type: types.FETCH_USER_LIST_REQUEST });
        userdetailsApi.getRejectedRolesList()
            .then(function (response) {
                // console.log("getRejectedRolesList Action succ==>", response)
                dispatch({ type: types.FETCH_USER_LIST_REQUEST_COMPLETED, data: response.data.userList });
            })
            .catch(function (err) {
                // console.log("getRejectedRolesList action Error", err)
                dispatch({ type: types.FETCH_USER_LIST_REQUEST_ERROR, error: err });
            });
    }
}

// POST ACTIONS
export function addUserDetails(objModel) {
    // console.log("addUserDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_USER_REQUEST });
        userdetailsApi.addUser(objModel)
            .then(function (response) {
                // console.log("addUserDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Saved Successfully" });
                }
                dispatch({ type: types.ADD_USER_REQUEST_COMPLETED, data: response.data });
                history.push('/user/user-list');
            })
            .catch(function (err) {
                // console.log("addUserDetails action err", err)
                dispatch({ type: types.ADD_USER_REQUEST_ERROR, error: err });
            });
    }
}

// PUT ACTIONS
export function updateUserDetails(objModel) {
    // console.log("updateUserDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_USER_REQUEST });
        userdetailsApi.updateUser(objModel)
            .then(function (response) {
                // console.log("updateUserDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Updated Successfully" });
                }
                dispatch({ type: types.ADD_USER_REQUEST_COMPLETED, data: response.data });
                history.push('/user/user-list');
            })
            .catch(function (err) {
                // console.log("updateUserDetails action err", err)
                dispatch({ type: types.ADD_USER_REQUEST_ERROR, error: err });
            });
    }
}

// DELETE ACTIONS
export function deleteUserRole(user_id, objModel) {
    // console.log("deleteUserRole action call",objModel);
    return dispatch => {
        dispatch({ type: types.DELETE_USER_ROLE_REQUEST });
        userdetailsApi.deleteUserRole(user_id, objModel)
            .then(function (response) {
                // console.log("deleteUserRole action succ", response)
                if (response.status == 200) {
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Deleted Successfully" });
                }
                dispatch({ type: types.DELETE_USER_ROLE_REQUEST_COMPLETED, data: response.data });
                // history.push('/user/add-user/' + user_id);
            })
            .catch(function (err) {
                // console.log("deleteUserRole action err", err)
                dispatch({ type: types.DELETE_USER_ROLE_REQUEST_ERROR, error: err });
            });
    }
}

export function grant(user_id, device_count) {
    // console.log("grant action call",objModel);
    return dispatch => {
        dispatch({ type: types.GRANT_USER_REQUEST });
        userdetailsApi.grant(user_id, device_count)
            .then(function (response) {
                // console.log("grant action succ", response)
                if (response.status == 200) {
                    history.push('/user/user-list');
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: response.data });
                }
                dispatch({ type: types.GRANT_USER_REQUEST_COMPLETED });
            })
            .catch(function (err) {
                // console.log("grant action err", err)
                dispatch({ type: types.GRANT_USER_REQUEST_ERROR });
            });
    }
}

export function grantArchiveMeeting(user_id) {
    // console.log("grant action call",objModel);
    return dispatch => {
        dispatch({ type: types.ACTION_USER_REQUEST });
        userdetailsApi.grantArchiveMeeting(user_id)
            .then(function (response) {
                // console.log("grant action succ", response)
                if (response.status == 200) {
                    // history.push('/user/user-list');
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: response.data });
                }
                dispatch({ type: types.ACTION_USER_REQUEST_COMPLETED });
            })
            .catch(function (err) {
                // console.log("grant action err", err)
                dispatch({ type: types.ACTION_USER_REQUEST_ERROR });
            });
    }
}

export function revoke(user_id) {
    // console.log("revoke action call",objModel);
    return dispatch => {
        dispatch({ type: types.ACTION_USER_REQUEST });
        userdetailsApi.revoke(user_id)
            .then(function (response) {
                // console.log("revoke action succ", response)
                if (response.status == 200) {
                    history.push('/user/user-list');
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: response.data });
                }
                dispatch({ type: types.ACTION_USER_REQUEST_COMPLETED });
            })
            .catch(function (err) {
                // console.log("revoke action err", err)
                dispatch({ type: types.ACTION_USER_REQUEST_ERROR });
            });
    }
}

export function unlock(user_id) {
    // console.log("unlock action call",objModel);
    return dispatch => {
        dispatch({ type: types.ACTION_USER_REQUEST });
        userdetailsApi.unlock(user_id)
            .then(function (response) {
                // console.log("unlock action succ", response)
                if (response.status == 200) {
                    // history.push('/user/user-list');
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: response.data });
                }
                dispatch({ type: types.ACTION_USER_REQUEST_COMPLETED });
            })
            .catch(function (err) {
                // console.log("unlock action err", err)
                dispatch({ type: types.ACTION_USER_REQUEST_ERROR });
            });
    }
}

export function lock(user_id) {
    // console.log("unlock action call",objModel);
    return dispatch => {
        dispatch({ type: types.ACTION_USER_REQUEST });
        userdetailsApi.lock(user_id)
            .then(function (response) {
                // console.log("unlock action succ", response)
                if (response.status == 200) {
                    // history.push('/user/user-list');
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: response.data });
                }
                dispatch({ type: types.ACTION_USER_REQUEST_COMPLETED });
            })
            .catch(function (err) {
                // console.log("unlock action err", err)
                dispatch({ type: types.ACTION_USER_REQUEST_ERROR });
            });
    }
}

export function resetpassword(user_id) {
    // console.log("resetpassword action call",objModel);
    return dispatch => {
        dispatch({ type: types.ACTION_USER_REQUEST });
        userdetailsApi.resetpassword(user_id)
            .then(function (response) {
                // console.log("resetpassword action succ", response)
                if (response.status == 200) {
                    // history.push('/user/user-list');
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: response.data });
                }
                dispatch({ type: types.ACTION_USER_REQUEST_COMPLETED });
            })
            .catch(function (err) {
                // console.log("resetpassword action err", err)
                dispatch({ type: types.ACTION_USER_REQUEST_ERROR });
            });
    }
}

export function deleteUser(user_id) {
    // console.log("deleteUser action call",objModel);
    return dispatch => {
        dispatch({ type: types.ACTION_USER_REQUEST });
        userdetailsApi.deleteUser(user_id)
            .then(function (response) {
                // console.log("deleteUser action succ", response)
                if (response.status == 200) {
                    history.push('/user/user-list');
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: response.data });
                }
                dispatch({ type: types.ACTION_USER_REQUEST_COMPLETED });
            })
            .catch(function (err) {
                // console.log("deleteUser action err", err)
                dispatch({ type: types.ACTION_USER_REQUEST_ERROR });
            });
    }
}

export function deleteRejectedUser(user_id) {
    // console.log("deleteUser action call",objModel);
    return dispatch => {
        dispatch({ type: types.ACTION_USER_REQUEST });
        userdetailsApi.deleteRejectedUser(user_id)
            .then(function (response) {
                // console.log("deleteUser action succ", response)
                if (response.status == 200) {
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: response.data });
                    history.push('/user/checker-rejected-roles');
                }
                dispatch({ type: types.ACTION_USER_REQUEST_COMPLETED });
            })
            .catch(function (err) {
                // console.log("deleteUser action err", err)
                dispatch({ type: types.ACTION_USER_REQUEST_ERROR });
            });
    }
}

export function approveUser(user_id) {
    // console.log("approveUser action call",objModel);
    return dispatch => {
        dispatch({ type: types.ACTION_USER_REQUEST });
        userdetailsApi.approveUser(user_id)
            .then(function (response) {
                // console.log("approveUser action succ", response)
                if (response.status == 200) {
                    getUserDetailsList();
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: response.data });
                    history.push('/user/checker-pending-approval');
                }
                dispatch({ type: types.ACTION_USER_REQUEST_COMPLETED });
            })
            .catch(function (err) {
                // console.log("approveUser action err", err)
                dispatch({ type: types.ACTION_USER_REQUEST_ERROR });
            });
    }
}

export function rejectUser(user_id) {
    // console.log("rejectUser action call",objModel);
    return dispatch => {
        dispatch({ type: types.ACTION_USER_REQUEST });
        userdetailsApi.rejectUser(user_id)
            .then(function (response) {
                // console.log("rejectUser action succ", response)
                if (response.status == 200) {
                    getUserDetailsList();
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: response.data });
                    history.push('/user/checker-pending-approval');
                }
                dispatch({ type: types.ACTION_USER_REQUEST_COMPLETED });
            })
            .catch(function (err) {
                // console.log("rejectUser action err", err)
                dispatch({ type: types.ACTION_USER_REQUEST_ERROR });
            });
    }
}

export function updateUserOrder(user_id, order_number, oldIndex) {
    // console.log("rejectUser action call",objModel);
    return dispatch => {
        dispatch({ type: types.ACTION_USER_REQUEST });
        userdetailsApi.updateUserOrder(user_id, order_number, oldIndex)
            .then(function (response) {
                // console.log("rejectUser action succ", response)
                if (response.status == 200) {
                    getUserDetailsList();
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: response.data });
                    // history.push('/user/checker-pending-approval');
                }
                dispatch({ type: types.ACTION_USER_REQUEST_COMPLETED });
            })
            .catch(function (err) {
                // console.log("rejectUser action err", err)
                dispatch({ type: types.ACTION_USER_REQUEST_ERROR });
            });
    }
}



// WEBPACK FOOTER //
// ./actions/userdetails.js